import axios from "@/util/axios";
import { getApiPath } from "@/util/utils";
const baseUrl = getApiPath();

export const resetPassword = (feather, data) => {
  return axios({
    url: `${baseUrl}${feather}`,
    method: "post",
    data: data
  });
};

export const APISERVER = (feather, data) => {
  return axios({
    url: `${baseUrl}${feather}`,
    method: "post",
    data: data
  });
};

export const APIGET = (feather, data) => {
  return axios({
    url: `${baseUrl}${feather}`,
    method: "get",
    params: data
  });
};

export const NEWAPIGET = (feather, data) => {
  return axios({
    url: `${baseUrl}${feather}`,
    method: "get",
    params: data
  });
};

export const getPasswordRule = () => {
  return axios({
    url: `${baseUrl}/srm-system/passwordpolicy/detail`,
    method: "get"
  });
};

export const getSRMToken = (params) => {
  return axios( {
    url: `/apis/srm-auth/oauth/getSrmTokenByPortalToken`,
    method: "get",
    params: params
  })
}

export const getSupplierPrivilege = () => {
  return axios( {
    url: `/apis/srm-supplier-portal/supplier/getSupplierPrivilege`,
    method: "get",
    params: {}
  })
}
